(function () {
  window.MediterraneanGlowObservers = window.MediterraneanGlowObservers || new Map();

  function init(root) {
    if (!root || root.dataset.mgInitialized === 'true') return;
    root.dataset.mgInitialized = 'true';

    var items = root.querySelectorAll('.mg-reveal');
    if (!items.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      items.forEach(function (item) { item.classList.add('mg-visible'); });
      return;
    }

    root.classList.add('mg-motion-ready');
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('mg-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

    items.forEach(function (item, index) {
      item.style.transitionDelay = ((index % 4) * 90) + 'ms';
      observer.observe(item);
    });

    window.MediterraneanGlowObservers.set(root.id, observer);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-mg-section]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('[data-mg-section]');
    if (!root) return;
    var observer = window.MediterraneanGlowObservers.get(root.id);
    if (observer) observer.disconnect();
    window.MediterraneanGlowObservers.delete(root.id);
  });
})();
